<template>
  <a-modal
    :visible="Visible"
    title="Đổi mật khẩu"
    :confirm-loading="IsLoading"
    ok-text="ĐỔI MẬT KHẨU"
    cancel-text="ĐÓNG"
    @ok="Submit"
    @cancel="Close"
  >
    <a-form layout="vertical" @submit.prevent>
      <a-form-item label="Mật khẩu hiện tại">
        <a-input-password
          v-model="Form.OldPassword"
          placeholder="Nhập mật khẩu hiện tại"
          @pressEnter="Submit"
        />
      </a-form-item>

      <a-form-item label="Mật khẩu mới">
        <a-input-password
          v-model="Form.NewPassword"
          placeholder="Nhập mật khẩu mới"
          @pressEnter="Submit"
        />
      </a-form-item>

      <a-form-item label="Nhập lại mật khẩu mới">
        <a-input-password
          v-model="Form.ConfirmPassword"
          placeholder="Nhập lại mật khẩu mới"
          @pressEnter="Submit"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import md5 from "md5";
import { mapState } from "vuex";

/*
 * Import PostAPI đúng từ service.js
 * mà project hiện tại đang dùng.
 */
// import {
//     PostAPI
// } from '...';

export default {
  name: "User_ChangePass",

  props: {
    value: {
      type: Boolean,

      default: false,
    },
  },

  data() {
    return {
      IsLoading: false,

      Form: {
        OldPassword: "",
        NewPassword: "",
        ConfirmPassword: "",
      },
    };
  },

  computed: {
    ...mapState([
      "isLogin",
      "oUser"
    ]),
    Visible() {
      return this.value;
    },
  },

  methods: {
    ResetForm() {
      this.Form = {
        OldPassword: "",
        NewPassword: "",
        ConfirmPassword: "",
      };
    },

    Close() {
      if (this.IsLoading) {
        return;
      }

      this.ResetForm();

      this.$emit("input", false);
    },

    Validate() {
      if (!this.Form.OldPassword) {
        this.$message.warning("Vui lòng nhập mật khẩu hiện tại.");

        return false;
      }

      if (!this.Form.NewPassword) {
        this.$message.warning("Vui lòng nhập mật khẩu mới.");

        return false;
      }

      if (this.Form.NewPassword.length < 6) {
        this.$message.warning("Mật khẩu mới tối thiểu 6 ký tự.");

        return false;
      }

      if (this.Form.NewPassword !== this.Form.ConfirmPassword) {
        this.$message.warning("Mật khẩu nhập lại không khớp.");

        return false;
      }

      if (this.Form.OldPassword === this.Form.NewPassword) {
        this.$message.warning("Mật khẩu mới phải khác mật khẩu hiện tại.");

        return false;
      }

      return true;
    },

    async Submit() {
      if (this.IsLoading || !this.Validate()) {
        return;
      }

      this.IsLoading = true;
      try {
        const oResult = await this.$PostAPI("/user/change-password", {
          Token: this.oUser.Token,

          Old_Password: md5(this.Form.OldPassword),

          New_Password: md5(this.Form.NewPassword),
        });

        if (!oResult || oResult.State !== 1) {
          this.$message.error(
            oResult && oResult.Message
              ? oResult.Message
              : "Không đổi được mật khẩu.",
          );

          return;
        }

        this.$message.success(oResult.Message || "Đổi mật khẩu thành công.");

        this.ResetForm();

        this.$emit("input", false);

        this.$emit("success");
      } catch (err) {
        console.log(err);
        this.$message.error("Không đổi được mật khẩu.");
      } finally {
        this.IsLoading = false;
      }
    },
  },
};
</script>
